// src/components/FullscreenDraftEditor.jsx
import React, { useEffect } from 'react'
import { Editor } from 'react-draft-wysiwyg'
import { EDITOR_TOOLBAR, STYLE_MAP } from './editorToolbar'
import FontFamilyControl from './FontFamilyControl'

const FullscreenDraftEditor = ({ editorState, onChange, onClose, setActiveFont }) => {
  useEffect(() => {
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => { document.body.style.overflow = prev }
  }, [])

  return (
    <div className="va__fs">
      <div className="va__fs-bar">
        <span>Editor en pantalla completa</span>
        <div className="va__fs-tools">
          <FontFamilyControl editorState={editorState} setEditorState={onChange} setActiveFont={setActiveFont}  />
          <button type="button" className="btn btn--ghost" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>

      <div className="va__fs-body">
        <Editor
          editorState={editorState}
          onEditorStateChange={onChange}
          wrapperClassName="va__fs-wrapper"
          toolbarClassName="va__fs-toolbar"
          editorClassName="va__fs-editor"
          toolbar={EDITOR_TOOLBAR}
          customStyleMap={STYLE_MAP}
          editorStyle={{ color: '#111' }}
        />
        <div className="va__fs-hint">Los cambios se guardan directamente en el formulario.</div>
      </div>
    </div>
  )
}

export default FullscreenDraftEditor
